import { DeepMap, FieldError, FieldPath, FieldValues, UseControllerProps } from 'react-hook-form';
import ReactDatePickerFormInput from './ReactDatePickerFormInput';

type SmartFormInputDateProps<T> = UseControllerProps<T & FieldValues> & {
  name: FieldPath<T & FieldValues>;
  errors?: Partial<DeepMap<T & FieldValues, FieldError>>;
  placeholder?: string;
  label?: string;
  /**
   * Expected output format:
   * - 'date-object': Form field expects Date objects (default)
   * - 'date-string': Form field expects YYYY-MM-DD strings
   */
  outputFormat?: 'date-object' | 'date-string';
  disabled?: boolean;
  /**
   * Maximum selectable date.
   * - If not provided, defaults to today (for date of birth scenarios)
   * - If set to null, no maximum date restriction (allows future dates for expiry dates)
   * - If set to a Date, uses that specific date as maximum
   */
  maxDate?: Date | null;
};

const SmartFormInputDate = <T extends FieldValues>({
  control,
  name,
  errors = {},
  placeholder,
  label,
  outputFormat = 'date-object',
  disabled = false,
  maxDate,
  ...other
}: SmartFormInputDateProps<T>) => {
  // Use the new ReactDatePickerFormInput for better cross-browser support
  return (
    <ReactDatePickerFormInput
      control={control}
      name={name}
      errors={errors}
      placeholder={placeholder}
      label={label}
      outputFormat={outputFormat}
      disabled={disabled}
      maxDate={maxDate}
      {...other}
    />
  );
};

export default SmartFormInputDate;
